import { DrEntity } from './dr-entity';

export class MonitoringNode extends DrEntity {
    aeComponentMonitorStatus: string
    analyticNodeMode: string
    attributes: Array<any>;
    connectorMonitorStatus: string;
    contact: string;
    description: string
    ipAddress: string
    location: string
    monitorStatus: string
    name: string
    nodeType: string
    numberCores: number
    numberThreadsExecuting: number
    storageExport: string
    storageMonitorStatus: string
    storageName: string;

    // off-model display values
    statusIconClass: string;
    statusIconColor: string;
    tooltip: string;

    constructor(value?: Partial<MonitoringNode>) {
        super(value);
        if (value) {
            Object.assign(this, value);
            switch (this.aeComponentMonitorStatus) {
                case 'AVAILABLE': {
                    this.statusIconClass = 'fa-check';
                    this.statusIconColor = 'color-green-04';
                    this.tooltip = 'Available';
                    break;
                }
                case 'WARNING': {
                    this.statusIconClass = 'fa-exclamation-triangle';
                    this.statusIconColor = 'color-tan-07';
                    this.tooltip = 'warning';
                    break;
                }
                case 'FAILURE': 
                case 'CRITICAL': {
                    this.statusIconClass = 'fa-exclamation-circle';
                    this.statusIconColor = 'color-red-05';
                    this.tooltip = 'Critical / Failure';
                    break;
                }
                case 'NOTLICENSED': {
                    this.statusIconClass = 'fa-certificate';
                    this.statusIconColor = 'color-purple-03';
                    this.tooltip = 'Not Licensed';
                    break;
                }
                case 'UNKNOWN': {
                    this.statusIconClass = 'fa-question-circle';
                    this.statusIconColor = 'color-grey-08';
                    this.tooltip = 'Unknown';
                    break;
                }
                case 'DEACTIVATED': {
                    this.statusIconClass = 'fa-times-circle';
                    this.statusIconColor = 'color-grey-08';
                    this.tooltip = 'Deactivated';
                    break;
                }
            }
        }
    }
}